import { CM_PAGE_LOAD_REQUEST } from '../actionTypes/CMPageActionTypes';

const getCMPageTemplateData = (
    params,
    aggregateAPI,
    cmFallbackEnabled,
    cmFallbackPreferences,
    redirectAction,
    location,
    history,
    initialLoad = true,
    showErrorPage = true
) => ({
    type: CM_PAGE_LOAD_REQUEST,
    payload: {
        params,
        aggregateAPI,
        cmFallbackEnabled,
        cmFallbackPreferences,
        redirectAction,
        location,
        history,
        initialLoad,
        showErrorPage,
    },
});

export default {
    getCMPageTemplateData,
};
